module.exports = new Promise(resolve => {
            const script = document.createElement('script');
            script.src = window.location.origin + '/mfe/claims/remoteEntry.js';
            script.onload = () => { resolve(window['claims']); };
            script.onerror = () => { resolve({ get: () => Promise.resolve(() => () => 'Module claims unavailable'), init: () => {} }); };
            document.head.appendChild(script);
        });